import React from 'react'
import "./profile.css"
import { motion } from "framer-motion"
import profileImg from "../../assets/images/reactdark.png"
import Navbar from "../../components/nav/Navbar"
import { Facebook, GitHub, LinkedIn, Twitter } from "@mui/icons-material"
import NextButton from '../../components/nextbutton/NextButton'
import { Link } from 'react-router-dom'
import Navbarmobile from '../../components/navbarmobile/Navbarmobile'
import NextButtonMobile from '../../components/nextButtonMobile/NextButtonMobile'
const header = {
    hidden:{
        y: -200,
        transition:{type: "spring"}
    },
    visible:{
        y: 0
    }
}
const Profile = () => {
  return (
    <section className="profile"
    >
        <section className="profile-wrapper">
            <Navbar/>
            <Navbarmobile/>
            <Link to="/skills">
                <NextButtonMobile/>
            </Link>
            <Link to="/skills">
                <NextButton/>
            </Link>
            <header className="profile-header">
                <motion.h1
                    initial="hidden"
                    animate="visible"
                    transition={{type: "spring", delay: 1.6}}
                   variants={header}
                >My Profile</motion.h1>
            </header>
            <motion.div className="profile-intro"
                initial={{y: -200}}
                animate={{y: 0}}
                transition={{ type: "spring", delay: 3.7}}   
            >
                <p>Samuel Kwesi Afriyie</p>
                <p>Frontend Developer</p>
            </motion.div>
            <main className="profile-body">
                <motion.div className="main-profile-left"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{ease: 'easeInOut', delay: 3.5}}      
                >
                    <div className="image-container">
                        <img src={profileImg} alt="profile" className="react-logo"/>
                    </div>

                </motion.div>
                <motion.div className="main-profile-right"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{ease: 'easeInOut', delay: 3.4}}
                >
                    <motion.article className="socialcard"
                        whileHover={{x: -50, 
                            transition:{ type: "spring", duration: 0.8}}}
                    >
                        <div className="socialcard-wrapper">
                            <Facebook className="social-icon"/>
                        </div>
                    </motion.article>
                    <motion.article className="socialcard"
                        whileHover={{x: -50, 
                            transition:{ type: "spring", duration: 0.8}}}
                    >
                        <a href="https://github.com/Kwesi-dev" target="_blank" rel="noreferrer noopener">
                            <div className="socialcard-wrapper">
                                <GitHub className="social-icon"/>
                            </div>
                        </a>
                    </motion.article>
                    <motion.article className="socialcard"
                        whileHover={{x: -50, 
                            transition:{ type: "spring", duration: 0.8}}}
                    >
                        <a href="https://www.linkedin.com/in/afriyie-samuel-991419219" target="_blank" rel="noopener noreferrer">
                            <div className="socialcard-wrapper">
                                <LinkedIn className="social-icon"/>
                            </div>
                        </a>
                    </motion.article>
                    <motion.article className="socialcard"
                        whileHover={{x: -50, 
                            transition:{ type: "spring", duration: 0.8}}}
                    >
                        <a href="https://twitter.com/Kwesidev3" target="_blank" rel="noopener noreferrer">
                            <div className="socialcard-wrapper">
                                <Twitter className="social-icon"/>
                            </div>
                        </a>
                    </motion.article>
                </motion.div>
            </main>
        </section>
    </section>
  )
}

export default Profile